import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { FaTrash } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import { AssetDisposeApi } from "../../../services/AssetService";
import { toast } from "react-toastify";
const AssetDisposeModal = ({
  id,
  open,
  onClose,
  afterSubmit,
  title = "Dispose Unit",
  message = "Are you sure you want to dispose this asset unit? This action cannot be undone.",
}) => {
  const [reason, setReason] = useState("");
  const[loading,setLoading]=useState(false)
  useEffect(() => {
    if (open) {
      setReason("");
    }
  }, [open]);
    const handleDsiposeUnit = () => {
      setLoading(true);
      AssetDisposeApi(id,{disposal_reason: reason })
        .then((res) => {
          toast.success("Dispose Successfully");
          afterSubmit()
        })
        .catch((err) => {
          toast.error(
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-danger">
        <FaTrash  /> {title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" className="mb-3">
          {message}
        </Typography>
        <TextField
          autoFocus
          label="Reason for Disposal"
          multiline
          rows={3}
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason for disposing this asset unit..."
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleDsiposeUnit}
          variant="contained"
          color="error"
          disabled={!reason.trim()}
        >
          {loading && <Spinner animation="border" size="sm" />}
          Confirm Dispose
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetDisposeModal;
